<!--
 * @Author: NZJ
 * @Date: 2023-11-16
 * @Description: 二次登录校验
-->
<template>
  <div class="login-second-box">
    <i class="iconfont iconfanhui" @click="reBack"></i>
    <div class="title">JMS-VIP</div>
    <el-form ref="LoginSecondForm" :model="formData" :rules="rules">
      <el-form-item prop="radioType">
        <el-radio-group v-model="formData.radioType">
          <el-radio :label="2">{{ $lang('邮箱') }}</el-radio>
          <el-radio :label="1">{{ $lang('手机号') }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item>
        <div class="userData" v-show="formData.radioType===1">{{$lang("联系人电话")}}：{{userData.contactMobile}}</div>
        <div class="userData" v-show="formData.radioType===2">{{$lang("联系人邮箱")}}：{{userData.email}}</div>
      </el-form-item>
      <el-form-item prop="code">
        <el-input :placeholder="$lang('请输入')" v-model="formData.code" autocomplete="off" maxlength="6">
        </el-input>
          <span class="getPhoneCode" @click="getCode" :loading="loading" v-if="regainGetCode" :title="$lang('获取验证码')">{{$lang('获取验证码')}}</span>
          <span class="getPhoneCode" v-else>{{ time }}s</span>
      </el-form-item>
      <el-button type="primary" class="login-btn" @click="login" v-loading="submitLoading">{{$lang('确定')}}</el-button>
    </el-form>
  </div>
</template>

<script>
import { RULES } from '@utils/rules'
import * as Api from '@api/base/public'
import { RESPONSE_SUCCESS } from '@constants'

export default {
  name: 'LoginSecondaryVerification',
  props: {
    loginForm: {
      type: Object,
      default: () => ({})
    },
    userData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    const codeValid = (rule, value, callback) => {
      if (value && value.length < 6) {
        callback(new Error(this.$lang('请输入正确的验证码')))
      } else {
        callback()
      }
    }
    return {
      time: 180,
      regainGetCode: true,
      codeTimer: null,
      loading: false,
      submitLoading: false,
      formData: {
        code: '',
        radioType: 2
      },
      rules: {
        code: [RULES.required, { validator: codeValid }]
      }
    }
  },
  computed: {
    // 国际化语言
    lang() {
      return this.$store.state.base.lang
    }
  },
  created() {
  },
  mounted() {
    this.initTencentCaptcha()
  },
  methods: {
    // 初始化tx验证码
    initTencentCaptcha() {
      // 生成实例对象
      const LanguageList = { ES: 'es', EN: 'en', CN: 'zh-cn' }
      this.captcha = this.$Captcha.init(this.tencentCaptchaCallback, { userLanguage: LanguageList[this.lang] })
    },
    // 验证码回调
    async tencentCaptchaCallback(res) {
      console.log('腾讯验证码回调：callback', res)
      // 验证成功，返回对象
      if (res.ret === 0) {
        // 定义参数：票据 随机字符串
        const customParams = {
          ticket: res.ticket,
          randstr: res.randstr
        }
        this.getCodeFn(customParams)
      }
      // 验证不成功
      return null
    },
    // 获取验证码
    async getCodeFn(customParams) {
      this.loading = true
      const { account, pwd } = this.loginForm
      const { radioType } = this.formData
      const params = {
        account,
        pwd: this.$md5(pwd + 'jadada236t2').toUpperCase(),
        radioType,
        ...customParams
      }
      const { code, data, msg } = await Api.userSmsVerification(params)
      this.loading = false
      if (code === RESPONSE_SUCCESS) {
        this.regainGetCode = false
        this.$message.success(data)
        clearInterval(this.codeTimer)
        this.codeTimer = setInterval(() => {
          this.time--
          if (this.time === 0) {
            this.time = 180
            this.regainGetCode = true
            clearInterval(this.codeTimer)
          }
        }, 1000)
      } else {
        this.$message.error(msg)
      }
    },
    /**
     * @description 获取手机短信验证码
     */
    async getCode() {
      this.captcha.show()
    },
    // 登录
    async login() {
      this.$refs.LoginSecondForm.validate(async (valid) => {
        if (valid) {
          const { code } = this.formData
          const { account, pwd } = this.loginForm
          const params = {
            account,
            pwd: this.$md5(pwd + 'jadada236t2').toUpperCase(),
            code
          }
          this.submitLoading = true
          const res = await Api.loginWithcode(params)
          this.submitLoading = false
          if (res && res.succ) {
            this.$emit('secondLogin', res)
          } else {
            this.$message.error(res.msg)
          }
        }
      })
    },
    /**
     * @description 返回
     */
    reBack() {
      // this.time = 180
      // this.regainGetCode = true
      // this.codeTimer = null
      // this.$refs.LoginSecondForm.resetFields()
      this.$emit('reBack')
    }
  }
}
</script>

<style lang="scss" scoped>
.login-second-box{
  .title{
    font-size: 20px;
    font-weight: 500;
    line-height: 30px;
    text-align: center;
    letter-spacing: 6px;
    height: 70px;
    margin-bottom: 40px;
  }
  .login-btn{
    width: 100%;
    padding: 0;
    height: 40px;
    line-height: 40px;
    border: none;
    border-radius: 4px;
    background:linear-gradient(90deg,rgba(230,0,18,1) 0%,rgba(230,0,18,1) 100%);
    font-size: 16px;
    margin-top: 30px;
  }
  .getPhoneCode{
    position: absolute;
    cursor: pointer;
    right: 0;
    padding: 0 15px;
    bottom: 0px;
    color: #e60012;
    white-space: nowrap;
    width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: right;
  }
  .iconfont.iconfanhui {
    position: absolute;
    left: 40px;
    font-size: 25px;
    cursor: pointer;
    color: #e60012;
  }
  ::v-deep {
    .el-form-item {
      margin-bottom: 10px;
    }
    .el-radio__label {
      color: #ffffff;
    }
    .is-checked {
      color: #e60012;
    }
  }
}
</style>
